import { defaultTo } from "lodash";
import { IModel, Model, ModelRecord, SpeciesModel } from "@common/models";

export interface IQuestionSpeciesModel extends IModel {
    questionSpeciesId: number;
    questionId: number;
    speciesId: number;
    species: SpeciesModel;
}

export class QuestionSpeciesModel extends Model implements ModelRecord<IQuestionSpeciesModel> {
    questionSpeciesId: number;
    questionId: number;
    speciesId: number;
    species: SpeciesModel;

    constructor(params?: Partial<IQuestionSpeciesModel>) {
        super(params);
        this.questionSpeciesId = defaultTo(params?.questionSpeciesId, 0);
        this.questionId = defaultTo(params?.questionId, 0);
        this.speciesId = defaultTo(params?.speciesId, 0);
        this.species = params?.species ? new SpeciesModel(params?.species) : new SpeciesModel();
    }
}
